import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { SubscriberService } from './subscriber.service';

@Injectable({
  providedIn: 'root'
})
export class SubscribeConfirmResolver {

  constructor(private ss: SubscriberService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<Boolean> {
    return this.ss.confirmOne(route.params['id']);
  }
}
